define.alias("ember-power-select/components/power-select/no-matches-message", "calendar/components/power-select/no-matches-message");